export default (nestedObj, path) => {
  const pathArr = path.split(".");
  return pathArr.reduce(
    (object, index) =>
      object && object[index] !== "undefined" ? object[index] : null,
    nestedObj,
  );
};
